const validateForm = (isEditIssuanceType, data) => {
  let errors = { hasError: false, msg: {} };
  if (!data.name) {
    errors.hasError = true;
    errors.name = true;
  }

  if (!data.departmentId) {
    errors.hasError = true;
    errors.departmentId = true;
  }

  if (typeof data.status !== 'number') {
    errors.hasError = true;
    errors.status = true;
  }

  return errors;
};

export default validateForm;
